export default "__VITE_ASSET__3b968ac2__"